<template>
  <div>
    <ButtonComponent :label="triggerLabel" @click="open" />

    <component :is="portal">
      <ModalComponent :show.sync="show" clickaway>
        <Card
          theme="flat"
          tag="form"
          @submit.prevent
          :thumbnail="thumbnail"
          class="subscription-modal"
          :class="`subscription-modal--align-${align}`"
        >
          <template #default>
            <div class="subscription-modal__content">
              <h3 class="subscription-modal__title">{{ title }}</h3>
              <p class="subscription-modal__description">{{ description }}</p>

              <template v-if="items.length">
                <p class="subscription-modal__cancel-reason">{{ $t('cancelReason') }}</p>

                <Radio :items="items" v-model="selectedComp" class="subscription-modal__radio">
                  <template #sublabel="{ item }">
                    <InputComponent
                      v-if="selected === item.value && item.textField"
                      class="subscription-modal__textarea"
                      :label="item.textFieldLabel || $t('description')"
                      data-widget="description"
                      :required="item.required"
                    >
                      <textarea
                        v-model="textField"
                        rows="3"
                        class="elder-input__element"
                        style="resize: vertical"
                        :placeholder="$t('typeHere') + '...'"
                      ></textarea>
                    </InputComponent>
                  </template>
                </Radio>
              </template>
            </div>
          </template>
          <template #footer>
            <ButtonComponent :label="$t('cancel')" @click="close" />
            <ButtonComponent
              :label="$t('confirm')"
              :icon="['fal', 'arrow-to-right']"
              :promise="promise"
              theme="primary"
              :disabled="disabled"
              @click="confirm"
            />
          </template>
        </Card>
      </ModalComponent>
    </component>
  </div>
</template>
<script>
import { InputComponent } from 'vue-elder-input'
import Radio from '@kvass/radio'

import Card from '@/components/Card'
import { ModalComponent } from 'vue-elder-modal'

import Portal from '@/components/Portal'

export default {
  props: {
    align: {
      type: String,
      default: 'left',
    },
    thumbnail: String,
    triggerLabel: String,
    title: String,
    description: String,

    promise: Promise,
    items: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      show: false,
      selected: null,
      textField: '',
      portal: Portal,
    }
  },

  watch: {
    promise(val) {
      if (!val) return
      val.then(() => this.close())
    },
  },

  computed: {
    selectedComp: {
      get() {
        return this.selected
      },
      set(val) {
        this.textField = ''
        this.selected = val
      },
    },

    disabled() {
      if (!this.items.length) return false
      if (!this.selected) return true
      const item = this.items.find(item => item.value === this.selected)
      if (!item.required) return false
      return !Boolean(this.textField)
    },
  },
  methods: {
    confirm() {
      if (this.disabled) return

      this.$emit('input', [this.selected, this.textField].filter(Boolean).join('|'))

      if (!('promise' in this.$options.propsData)) this.close()
    },
    open() {
      this.show = true
    },
    close() {
      this.show = false
    },
  },
  components: {
    Card,
    ModalComponent,
    Radio,

    InputComponent,
  },
}
</script>

<style lang="scss">
.subscription-modal {
  &--align {
    &-center {
      .subscription-modal__content {
        text-align: center;
      }
    }
  }

  &__radio {
    min-height: 300px;
    flex-direction: column;

    .kvass-radio__wrapper {
      display: grid;
      grid-template-columns: auto 1fr;
      grid-template-areas:
        'radio label'
        'sublabel sublabel';

      & > div:last-of-type {
        display: contents;
      }
    }
    .kvass-radio__radio {
      grid-area: radio;
    }
    .kvass-radio__label {
      grid-area: label;
    }
    .kvass-radio__sublabel {
      display: contents;
    }
    .subscription-modal__textarea {
      margin-top: 1rem;
      grid-area: sublabel;
    }
  }

  &__content {
    max-width: 500px;
  }

  &__title {
    font-size: 1.5rem;
  }

  &__description {
  }

  &__cancel-reason {
    font-weight: bold;
  }

  .card__footer-content {
    justify-content: center;
  }
}
</style>
